module.exports = __webpack_public_path__ + "img/img-edea4b7d.2418a928.png";